// @flow
import dayjs from "dayjs";

import isPrivacyImage from "../../../assets/is-private.png";

const getReportPresenter = (props) => {
  const {
    category: { id: categoryId, name: categoryName },
    description: content,
    estimation,
    is_private: isPrivate,
    kelurahan,
    location,
    media,
    reported_at: createdDate,
    source: { id: sourceId, name: sourceName },
    status_histories: statusHistories,
    trace_no: traceNo,
  } = props;
  return {
    categoryId,
    categoryName,
    content: isPrivate && !content ? "Deskripsi Tidak Ditampilkan" : content,
    createdDate: dayjs(createdDate).format("DD MMM YYYY"),
    estimation,
    isPrivate,
    location,
    media:
      isPrivate && media.length === 0
        ? [
            {
              image_url: isPrivacyImage,
              media_url: isPrivacyImage,
              order: 0,
              type: "image",
            },
          ]
        : media,
    kelurahan,
    sourceId,
    sourceName,
    statusHistories,
    traceNo,
  };
};

export default getReportPresenter;
